import {
  ClockCircleOutlined,
  ApartmentOutlined,
  QrcodeOutlined,
  IdcardOutlined,
  UsergroupAddOutlined,
} from "@ant-design/icons";
import { Tabs } from "antd";
import ShiftPage from "./ShiftPage";
import { FaPeopleArrows } from "react-icons/fa6";

import LeaveTypeMaster from "./LeavTypePage";
import HolidayPage from "./HolidayPage";
import UserQRSannPage from "./UserQRSannPage";
import ApproverAssignments from "./ApproverAssignment/ApproverAssignments";
import ApprovalHierarchyManagement from "./TopApproval/ApprovalHierarchyManagement";
import IDCardDesigner from "./IDCard/IDCardDesigner";
import EmpHistoryMovement from "./HistoryMovement/EmpHistoryMovement";
const { TabPane } = Tabs;
const SetupType = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="ប្រភេទច្បាប់" key="2" icon={<FaPeopleArrows />}>
          <LeaveTypeMaster />
        </TabPane>
        <TabPane
          tab="កាលវិភាគម៉ោងធ្វើការ"
          key="3"
          icon={<ClockCircleOutlined />}
        >
          <ShiftPage />
        </TabPane>
        <TabPane
          tab="ថ្ងៃឈប់សម្រាកប្រចាំឆ្នាំ"
          key="5"
          icon={<ClockCircleOutlined />}
        >
          <HolidayPage />
        </TabPane>
        <TabPane
          tab="កំណត់ទីតាំងស្គេន QR វត្តមាន"
          key="6"
          icon={<QrcodeOutlined />}
        >
          <UserQRSannPage />
        </TabPane>
        <TabPane
          tab="អនុញ្ញាតច្បាប់ ជំនួស"
          key="4"
          icon={<ApartmentOutlined />}
        >
           <ApproverAssignments />
        </TabPane>
              <TabPane
          tab="ប្រធានអនុញ្ញាតច្បាប់ ចុងក្រោយ"
          key="7"
          icon={<UsergroupAddOutlined />}
        >
           <ApprovalHierarchyManagement />
        </TabPane>
          <TabPane
          tab="រចនាកាតបុគ្គលិក"
          key="8"
          icon={<IdcardOutlined />}
        >
           <IDCardDesigner />
        </TabPane>
          <TabPane
          tab="ផ្លាស់ប្តូរកន្លែងធ្វើរការ"
          key="9"
          icon={<IdcardOutlined />}
        >
           <EmpHistoryMovement />
        </TabPane>
      </Tabs>
    </div>
  );
};
export default SetupType;
